import { buildNeighborhoodOfficeSeo } from 'ux/Public/OfficeSeo/data/officeSeoNeighborhoodBuild';

export const nycCityOfficeSeo = buildNeighborhoodOfficeSeo({
  cityPathSegment: 'new-york',
  neighborhoodSlug: 'new-york-city',
  neighborhoodDisplayName: 'New York City',
  metroDisplayName: 'New York',
  totalCodiClientsInNeighborhood: 60,
  nycLocalPreset: 'manhattanStandard',
  whereFromStreetsToLandmark:
    'from offices across Midtown, Flatiron/NoMad, SoHo/Tribeca, Lower Manhattan, and Hudson Yards to the buildings near Grand Central and the Financial District',
  whereTeamStreets: '5th Ave, Broadway, 23rd St, 42nd St, Wall St, 10th Ave',
  clientDescriptor: 'a software startup near Midtown Manhattan',
  counts: {
    managedCleaningOffices: 45,
    managedPantryOffices: 60,
    managedInternetOffices: 55,
    managedFurnitureOffices: 35,
    managedOfficeAssistantOffices: 35,
    managedDeepCleaningOffices: 28,
    managedCarpetCleaningOffices: 20,
    managedWindowCleaningOffices: 18,
    managedGlassCleaningOffices: 30,
    managedWasteRecyclingOffices: 22,
    managedPantryInventoryOffices: 50,
    managedCoffeeServiceOffices: 40,
    managedWaterServiceOffices: 38,
    managedTeamLunchOffices: 25,
    managedBreakfastCateringOffices: 20,
    managedIndividualMealsOffices: 18,
    managedAdHocCateringOffices: 28,
    managedHappyHourOffices: 22,
    managedConferenceRoomAvOffices: 30,
    managedNetworkInstallationOffices: 48,
    managedNetworkManagementOffices: 38,
    managedCableManagementOffices: 24,
    managedRoomBookingOffices: 22,
    managedPrintingSetupOffices: 35,
    managedInteriorDesignOffices: 42,
    managedOfficeMuralsOffices: 18,
    managedOfficePaintingOffices: 28,
    managedGlassFrostingOffices: 35,
    managedOfficeSignageOffices: 22,
    managedCareRoomOffices: 16,
    managedFurnitureAssemblyOffices: 55,
    managedLayoutChangeOffices: 38,
    managedOfficePlantsOffices: 50,
    managedKeylessAccessOffices: 28,
    managedAlarmSystemsOffices: 18,
    managedSecurityCamerasOffices: 24,
    managedKeypadOffices: 20,
    managedLockboxOffices: 12,
    managedVisitorManagementOffices: 20,
    managedBusinessInsuranceOffices: 22,
    managedElectricalServicesOffices: 26,
    managedHvacOffices: 21,
    managedPlumbingOffices: 18,
    managedPestControlOffices: 16,
    managedOfficeMovingOffices: 24,
    managedMountingInstallationOffices: 35
  },
  quotes: {
    cleaning: "We didn't want to deal with elevator bookings and vendor coordination. Codi does it.",
    pantryRestocking: "Manhattan delivery windows are brutal. Codi figures it out so we don't have to.",
    internet:
      'NYC buildings require COI approvals before IT vendors can access your space. Codi coordinated everything with the building ops team.',
    officeAssistant: "Codi's on-site person handles packages, visitors, and vendor access \u2014 all of it.",
    officeFurniture:
      'Freight elevator booking for furniture deliveries is such a pain in Manhattan buildings. Codi handled it end-to-end.',
    deepCleaning:
      'NYC office buildings make deep clean coordination complicated. Codi manages all elevator bookings and insurance approvals.',
    carpetCleaning:
      'COI requirements for carpet vendors in Manhattan buildings are intense. Codi handles the entire approval process.',
    windowCleaning:
      'Manhattan high-rise window cleaning requires building permits and rappelling certification. Codi manages the vendor and access.',
    glassConferenceRoom:
      'Glass conference rooms in NYC offices see constant use. Codi keeps them spotless on a weekly schedule.',
    wasteRecycling:
      'NYC waste stream regulations are strict. Codi manages compliant sorting and scheduled pickup across all our offices.',
    pantryInventory:
      'Pantry inventory across Manhattan offices on autopilot \u2014 Codi tracks consumption and reorders before items run out.',
    coffeeService:
      'Coffee service across NYC offices. Codi manages equipment, bean sourcing, and maintenance for every Manhattan location.',
    waterService:
      'Filtered water dispensers across NYC offices, serviced on a schedule by Codi. Building access is pre-coordinated.',
    teamLunch:
      'Recurring team lunches across NYC offices. Codi handles vendor selection, elevator booking, and delivery coordination.',
    breakfastCatering:
      'Office breakfast programs across New York City. Codi coordinates early delivery access and sources reliable local vendors.',
    individualMeals:
      'Daily individual meal delivery for NYC offices. Codi manages all vendor relationships and delivery logistics citywide.',
    adHocCatering:
      'On-demand catering across NYC offices \u2014 board meetings, investor days, all-hands. Codi handles it every time.',
    happyHour:
      'Office happy hours across New York City. Codi manages drinks sourcing, freight access, and setup for every event.',
    conferenceRoomAv:
      'Conference room A/V across NYC offices \u2014 Codi manages COI approvals, installation coordination, and ongoing maintenance.',
    networkInstallation:
      'Network installations across Manhattan offices. Codi handles COI paperwork, ISP coordination, and managed network deployment.',
    networkManagement:
      'Managed network services across New York City offices. Codi monitors, maintains, and resolves issues for every office network.',
    cableManagement:
      'Cable management in NYC office buildings \u2014 Codi organizes cable infrastructure and meets building IT requirements citywide.',
    roomBooking:
      'Room-booking systems deployed across NYC offices. Codi manages hardware provisioning, software configuration, and IT approvals.',
    printingSetup:
      'Printer setup across Manhattan offices. Codi handles freight elevator booking, COI approval, installation, and driver config.',
    interiorDesign:
      'Interior design and space planning across NYC offices. Codi manages COI approvals, building coordination, and full fit-out management for Manhattan offices.',
    officeMurals:
      'Office murals across New York City. Codi coordinates building approval, artist selection, and installation for offices throughout Manhattan.',
    officePainting:
      'Office painting across NYC offices. Codi manages COI compliance, after-hours scheduling, and building management coordination for every painting project.',
    glassFrosting:
      'Glass frosting installation across Manhattan offices. Codi handles measurement, material sourcing, and installation scheduling for all NYC locations.',
    officeSignage:
      'Office signage across New York City. Codi manages building permits, fabrication, and installation for lobby, wayfinding, and brand wall projects.',
    careRoom:
      'Care room setups across NYC offices. Codi furnishes and equips private care rooms in Manhattan office buildings of all sizes.',
    furnitureAssembly:
      'Furniture assembly across NYC offices. Codi coordinates freight elevator access, COI compliance, and assembly crews for Manhattan locations citywide.',
    layoutChange:
      'Office layout changes across New York City. Codi manages furniture reconfiguration, cable rerouting, and building coordination for NYC offices.',
    officePlants:
      'Office plant programs across New York City. Codi sources, places, and maintains plants for offices in Flatiron, Midtown, SoHo, and throughout Manhattan.',
    keylessAccess:
      'Keyless access management across NYC offices. Codi handles COI coordination, installation, credential setup, and ongoing management for Manhattan offices citywide.',
    alarmSystems:
      'Alarm system installation across New York City offices. Codi manages vendor selection, building COI approvals, installation, and ongoing monitoring for NYC offices.',
    securityCameras:
      'Security camera installation across NYC offices. Codi manages building permits, camera placement, network integration, and ongoing management for Manhattan locations.',
    keypads:
      'Door keypad installation and management across New York City offices. Codi installs, configures, and manages access codes for offices throughout Manhattan.',
    lockboxes:
      'Office lockbox management across New York City. Codi coordinates placement, building security compliance, and access distribution for Manhattan offices.',
    visitorManagement:
      'Visitor management systems deployed across NYC offices. Codi handles hardware delivery, software setup, and compliance management for offices throughout Manhattan.',
    businessInsurance:
      'Business insurance coordination across NYC offices. Codi manages policy sourcing, COI generation, and annual renewals for offices in Midtown, Flatiron, SoHo, and throughout Manhattan.',
    electricalServices:
      'Electrical services across New York City offices. Codi manages licensed master electricians, DOB permits, and building coordination for electrical projects in Midtown, Flatiron, SoHo, and throughout Manhattan.',
    hvac: 'HVAC maintenance and repairs across NYC offices. Codi manages licensed HVAC vendors and building engineering coordination for offices in Midtown, Flatiron, Lower Manhattan, and all New York City neighborhoods.',
    plumbing:
      'Plumbing services across Manhattan offices. Codi coordinates licensed plumbers, DEP water shutoff scheduling, and building notifications for plumbing projects across NYC offices.',
    pestControl:
      'Pest control programs across New York City offices. Codi manages licensed PCO operators, quarterly treatment scheduling, and building compliance documentation for offices throughout Manhattan.',
    officeMoving:
      'Office moving coordination across New York City. Codi manages mover vetting, freight elevator booking, COI documentation, and full setup for office moves in Midtown, Flatiron, SoHo, and beyond.',
    mountingInstallation:
      'Mounting and installation services across NYC offices. Codi coordinates vetted installation vendors for TV, whiteboard, and signage mounting in offices throughout Manhattan \u2014 building permits handled.'
  },
  officeAssistant: {},
  metroWideDemandPullquote: 'all'
});
